import askDockerChatVue from '@/view/askDockerChat/index.vue'
const askDockerChat = {
  name: 'askDockerChat',
  component: askDockerChatVue,
  meta: {
    title: '问诊中',
    keepAlive: true
  }
}
export default askDockerChat
